import React from 'react';
import type { FilterItem } from '../../models/search-result';
import { DEFAULT_VISIBLE_FACET_VALUES } from './FilterSidebar.constants';
import type { FilterSidebarShowMoreState } from './useFilterSidebarState';

interface FilterItemsProps {
  items: FilterItem[];
  filterSectionId: string;
  showMoreStates: FilterSidebarShowMoreState;
  onToggleShowMore: (section: string) => void;
  onFilterToggle: (sectionId: string, filterItem: FilterItem) => void;
  isFilterChecked: (sectionId: string, filterItem: FilterItem) => boolean;
  limit?: number;
  stateKey?: string;
  wrapperClassName?: string;
}

const FilterItems: React.FC<FilterItemsProps> = ({
  items,
  filterSectionId,
  showMoreStates,
  onToggleShowMore,
  onFilterToggle,
  isFilterChecked,
  limit = DEFAULT_VISIBLE_FACET_VALUES,
  stateKey,
  wrapperClassName = '',
}) => {
  const sectionStateKey = stateKey || filterSectionId;
  const showMore = showMoreStates[sectionStateKey];
  const normalizedLimit = limit < 0 ? items.length : limit;
  const displayItems = showMore ? items : items.slice(0, normalizedLimit);

  return (
    <>
      {displayItems.map((item) => {
        const isChecked = isFilterChecked(filterSectionId, item);

        return (
          <div
            key={item.id}
            className={`filter-item-wrapper ${wrapperClassName}`.trim()}
          >
            <label className="filter-item">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => onFilterToggle(filterSectionId, item)}
              />
              <span className="filter-label">{item.label}</span>
              <span className="filter-count">
                ({item.count?.toLocaleString() || 0})
              </span>
            </label>
          </div>
        );
      })}
      {items.length > normalizedLimit && (
        <button
          type="button"
          className="show-more-btn"
          onClick={() => onToggleShowMore(sectionStateKey)}
        >
          {showMore ? 'Show Less' : 'Show All'}
        </button>
      )}
    </>
  );
};

export default FilterItems;
